export default __webpack_public_path__ + "static/media/DSC02608 Large.077b2753.jpg";